import request from '../request'
import type { ApiResponse } from '../types'
import type {
  memberPinVerifyRequest,
  memberPinVerifyResponse,
  memberProfileChangeavatarRequest,
  memberProfileChangenicknameRequest,
  memberProfileChangenicknameResponse,
  memberWalletFlowsRequest,
  memberAppealListParams,
  memberAppealListResponse,
  memberAppealListResponseItem,
  memberPaymentMethodListParams,
  memberPaymentMethodListResponse,
  memberPaymentMethodListItem,
  memberPaymentMethodAddRequest,
  memberPaymentMethodDelRequest,
  memberKycPreflightResponse,
  memberKycVerifyidentitycardRequest,
  memberKycLivecertifyRequest,
  memberKycLivecertifycommitRequest,
  memberRealnameVerifyRequest,
  memberRealnameVerifyResponse,
  agentPreflightResponse,
  agentApplyRequest,
  agentRefundRequest,
  agentCommissionListParams,
  agentCommissionListResponse,
  memberReportListParams,
  memberSecurityCenterParams,
  memberSecurityCenterResponse,
  memberSecurityActivityAddRequest,
  memberPhoneBindRequest,
  memberSecurityEmailSendBindRequest,
  memberSecurityEmailBindRequest,
  memberLoginV2Request,
  memberLoginV2Response,
  memberExchangeRequest,
  memberUpdatePwdRequest,
  memberSecurityStatusResponse,
  memberAccountUpgradeRequest,
  memberThirdPartyBindPreflightParams,
  memberThirdPartyBindPreflightResponse,
  memberThirdPartyBindConfirmRequest,
  memberThirdPartyBindConfirmResponse,
  memberThirdPartyBindDetailsParams,
  memberThirdPartyBindDetailsResponse,
  memberThirdPartyBindListRequest,
  memberThirdPartyBindListItem,
  memberThirdPartyUnbindConfirmRequest,
  memberFeedbackListParams,
  memberFeedbackListItem,
  memberFeedbackCommitRequest,
} from './types'
export * from './types'

/**
 * 验证支付密码
 */
export function memberPinVerifyApi(
  data: memberPinVerifyRequest,
): Promise<ApiResponse<memberPinVerifyResponse>> {
  return request.post('/member/pin/verify', data)
}

/**
 * 用户修改头像
 */
export function memberProfileChangeavatarApi(
  data: memberProfileChangeavatarRequest,
): Promise<ApiResponse<any>> {
  return request.post('/member/profile/change-avatar', data)
}

/**
 * 用户修改昵称
 */
export function memberProfileChangenicknameApi(
  data: memberProfileChangenicknameRequest,
): Promise<ApiResponse<memberProfileChangenicknameResponse>> {
  return request.post('/member/profile/change-nickname', data)
}

/**
 * 账单列表
 */
export function memberWalletFlowsApi(data: memberWalletFlowsRequest): Promise<ApiResponse<any>> {
  return request.post('/member/wallet/flows', data)
}

/**
 * 申述列表
 */
export function memberAppealListApi(
  params: memberAppealListParams,
): Promise<ApiResponse<memberAppealListResponse>> {
  return request.get('/member/appeal/list', { params })
}

/**
 * 用户支付列表
 */
export function memberPaymentMethodListApi(
  params: memberPaymentMethodListParams,
): Promise<ApiResponse<memberPaymentMethodListResponse>> {
  return request.get('/member/payment/method/list', { params })
}

/**
 * 快速卖币支付列表
 */
export function tradeC2cOrderFastSellPaymentListApi(): Promise<
  ApiResponse<{
    payments: string[]
  }>
> {
  return request.get('/trade/c2c/order/fast/sell/payment')
}

/**
 * 添加支付方式
 */
export function memberPaymentMethodAddApi(
  data: memberPaymentMethodAddRequest,
): Promise<ApiResponse<any>> {
  return request.post('/member/payment/method/add', data)
}
/**
 * 添加支付方式-预检
 */
export function memberPaymentMethodPreflightApi(
  data: memberPaymentMethodAddRequest,
): Promise<ApiResponse<any>> {
  return request.post('/member/payment/method/preflight', data)
}
/**
 * 修改支付方式备注
 */
export function memberPaymentMethodEditRemarkApi(data: {
  id: number
  remark: string
}): Promise<ApiResponse<any>> {
  return request.post('/member/payment/method/edit-remark', data)
}

/**
 * 删除支付方式
 */
export function memberPaymentMethodDelApi(
  data: memberPaymentMethodDelRequest,
): Promise<ApiResponse<any>> {
  return request.post('/member/payment/method/del', data)
}

/**
 * 设置默认支付方式
 */
export function memberPaymentMethodSetdefApi(
  data: memberPaymentMethodDelRequest,
): Promise<ApiResponse<any>> {
  return request.post('/member/payment/method/set-def', data)
}

/**
 * 页面初始数据
 */
export function memberKycPreflightApi(): Promise<ApiResponse<memberKycPreflightResponse>> {
  return request.get('/member/kyc/preflight')
}

/**
 * 身份证OCR
 */
export function memberKycVerifyidentitycardApi(
  data: memberKycVerifyidentitycardRequest,
): Promise<ApiResponse<any>> {
  return request.post('/member/kyc/verify-identity-card', data)
}

/**
 * 获取活体检测(SDK)链接
 */
export function memberKycLivecertifyApi(
  data: memberKycLivecertifyRequest,
): Promise<ApiResponse<any>> {
  return request.post('/member/kyc/live-certify', data)
}

/**
 * 活体检测成功后提交
 */
export function memberKycLivecertifycommitApi(
  data: memberKycLivecertifycommitRequest,
): Promise<ApiResponse<any>> {
  return request.post('/member/kyc/live-certify-commit', data)
}

/**
 * 实名认证 - 方便测试用
 */
export function memberRealnameBindApi(
  data: memberRealnameVerifyRequest,
): Promise<ApiResponse<memberRealnameVerifyResponse>> {
  return request.post('/member/realname/bind', data)
}

/**
 * 页面初始化数据
 */
export function agentPreflightApi(): Promise<ApiResponse<agentPreflightResponse>> {
  return request.get('/agent/preflight')
}

/**
 * 申请成为商家
 */
export function agentApplyApi(data: agentApplyRequest): Promise<ApiResponse<any>> {
  return request.post('/agent/apply', data)
}

/**
 * 申请退还保证金
 */
export function agentRefundApi(data: agentRefundRequest): Promise<ApiResponse<any>> {
  return request.post('/agent/refund', data)
}

/**
 * 商户佣金记录
 */
export function agentCommissionListApi(
  params?: agentCommissionListParams,
): Promise<ApiResponse<agentCommissionListResponse>> {
  return request.get('/agent/commission/list', { params })
}

/**
 * 举报列表
 */
export function memberReportListApi(params: memberReportListParams): Promise<ApiResponse<any>> {
  return request.get('/member/report/list', { params })
}

/**
 * 安全中心
 */
export function memberSecurityCenterApi(
  params: memberSecurityCenterParams,
): Promise<ApiResponse<memberSecurityCenterResponse>> {
  return request.get('/member/security/center', { params })
}

/**
 * 添加安全活动
 */
export function memberSecurityActivityAddApi(
  data: memberSecurityActivityAddRequest,
): Promise<ApiResponse<any>> {
  return request.post('/member/security/activity/add', data)
}

/**
 * 绑定手机
 */
export function memberPhoneBindApi(data: memberPhoneBindRequest): Promise<ApiResponse<any>> {
  return request.post('/member/phone/bind', data)
}

/**
 * 绑定邮箱
 */
export function memberSecurityEmailBindApi(
  data: memberSecurityEmailBindRequest,
): Promise<ApiResponse<any>> {
  return request.post('/member/security/email/bind', data)
}

/**
 * 登录 v2
 *
 * 备注：
 * 1. 请求头需携带 "Device-Id"（客户端自行生成并缓存，已由 request 拦截器自动注入）
 * 2. force_captcha=true 的触发场景：
 *    - 新用户登录
 *    - 请求头缺少 "Device-Id"
 *    - 风险分 > 60（登录 IP 不一致 25 分、设备不一致 45 分、
 *      10 分钟内失败 3 次 35 分、当天失败 10 次 25 分）
 * 3. captcha_no / captcha_param 仅在需要验证码时使用，登录后无论成功失败都须清空，不复用
 * 4. 密码错误返回 code=104，账号锁定返回 code=105，data.attempts 含锁定详情
 */
export function memberLoginV2Api(
  data: memberLoginV2Request,
): Promise<ApiResponse<memberLoginV2Response>> {
  return request.post('/member/login/v2', data)
}

/**
 * 模拟商户会员登录（行为与响应和登录接口完全一致）
 *
 * 备注：token 为商户会员登录接口返回的 URL 后带的 "mt" 值
 */
export function memberExchangeApi(
  data: memberExchangeRequest,
): Promise<ApiResponse<memberLoginV2Response>> {
  return request.post('/member/exchange', data)
}
/**
 * 修改密码
 */
export function memberUpdatePwdApi(data: memberUpdatePwdRequest): Promise<ApiResponse<any>> {
  return request.post('/member/update-pwd', data)
}
/**
 * 检查账号是否可用
 */
export function memberAccountCheckApi(params: { account: string }): Promise<
  ApiResponse<{
    available: boolean
  }>
> {
  return request.get('/member/account/check', { params })
}
/**
 * 检查安全状态（资金密码、手机、实名认证、登录账号）
 */
export function memberSecurityStatusApi(): Promise<ApiResponse<memberSecurityStatusResponse>> {
  return request.get('/member/security-status')
}
/**
 * 账号升级（即三方内嵌用户绑定成本站会员）
 */
export function memberAccountUpgradeApi(
  data: memberAccountUpgradeRequest,
): Promise<ApiResponse<any>> {
  return request.post('/member/account/upgrade', data)
}

/**
 * 绑定页面 - 数据初始化（解析 Token）
 */
export function memberThirdPartyBindPreflightApi(
  params: memberThirdPartyBindPreflightParams,
): Promise<ApiResponse<memberThirdPartyBindPreflightResponse>> {
  return request.get('/member/third-party/bind/preflight', { params })
}

/**
 * 确认绑定三方游戏商
 */
export function memberThirdPartyBindConfirmApi(
  data: memberThirdPartyBindConfirmRequest,
): Promise<ApiResponse<memberThirdPartyBindConfirmResponse>> {
  return request.post('/member/third-party/bind/confirm', data)
}

/**
 * 绑定详情
 */
export function memberThirdPartyBindDetailsApi(
  params: memberThirdPartyBindDetailsParams,
): Promise<ApiResponse<memberThirdPartyBindDetailsResponse>> {
  return request.get('/member/third-party/bind/details', { params })
}

/**
 * 绑定列表
 */
export function memberThirdPartyBindListApi(
  data: memberThirdPartyBindListRequest,
): Promise<ApiResponse<memberThirdPartyBindListItem[]>> {
  return request.post('/member/third-party/bind/list', data)
}

/**
 * 解绑三方游戏商
 */
export function memberThirdPartyUnbindConfirmApi(
  data: memberThirdPartyUnbindConfirmRequest,
): Promise<ApiResponse<Record<string, never>>> {
  return request.post('/member/third-party/unbind/confirm', data)
}

/**
 * 反馈列表
 */
export function memberFeedbackListApi(
  data: memberFeedbackListParams,
): Promise<ApiResponse<memberFeedbackListItem[]>> {
  return request.post('/member/feedback/list', data)
}

/**
 * 提交意见反馈
 */
export function memberFeedbackCommitApi(
  data: memberFeedbackCommitRequest,
): Promise<ApiResponse<any>> {
  return request.post('/member/feedback/commit', data)
}
